import loginCheck from './loginCheck'
import twofactorCheck from './twoFactorCheck'
import termsCheck from './termsCheck'
import changePassword from './changePassword'

export default {loginCheck, twofactorCheck, termsCheck, changePassword}
